import ErrorRanaIcon from "../assets/error-rana.svg?url";
import ErrorThreeDiIcon from "../assets/error-threedi.svg?url";
import ErrorIcon from "../assets/error.svg?url";

export type THEME = "lizard" | "rana" | "threedi";

interface DefaultErrorPageProps {
  theme?: THEME;
  /* Don't know if we are going to use these, but these are the properties Sentry can send */
  error: unknown;
  componentStack: string;
  resetError: () => void;
}

const getThemeIcon = (theme?: THEME) => {
  switch (theme) {
    case "rana":
      return <ErrorRanaIcon />;
    case "threedi":
      return <ErrorThreeDiIcon />;
    default:
      return <ErrorIcon />;
  }
};

const setBackgroundColor = (theme?: THEME) => {
  switch (theme) {
    case "rana":
      return "#69a0c9";
    case "lizard":
      return "#55bfa2";
    case "threedi":
      return "#e0002c";
    default:
      return "#55bfa2";
  }
};

export function DefaultErrorPage({ theme }: DefaultErrorPageProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: setBackgroundColor(theme),
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "30px",
          width: "80%",
          height: "60%",
          borderRadius: "22px",
          backgroundColor: "white",
          boxShadow: "0px 4px 18px 4px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            fontSize: "20px",
            margin: "0 10%",
          }}
        >
          <h1>Error occurred</h1>
          <p>Sorry, something went wrong! Our engineers have been notified.</p>
          <p>
            If the problem persists or you need any assistance, please contact{" "}
            <a
              href="https://nelen-schuurmans.topdesk.net/tas/public/login/saml"
              target="_blank"
              rel="noreferrer"
            >
              our Servicedesk
            </a>
            .
          </p>
          <button
            title="Reload the page"
            onClick={() => window.location.reload()}
            style={{
              margin: "20px 0",
              padding: "10px 20px",
              cursor: "pointer",
              backgroundColor: "#316489",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
            }}
          >
            Reload
          </button>
          <a href="/" style={{ color: "#316489" }}>
            Go home
          </a>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getThemeIcon(theme)}
        </div>
      </div>
    </div>
  );
}
